import {
  Avatar,
  Backdrop,
  Badge,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Checkbox,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Select,
  TextField,
  Typography
} from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import CloseIcon from '@material-ui/icons/Close';
import CropFreeIcon from '@material-ui/icons/CropFree';
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import DeveloperBoardIcon from '@material-ui/icons/DeveloperBoard';
import DeviceUnknownIcon from '@material-ui/icons/DeviceUnknown';
import ExtensionIcon from '@material-ui/icons/Extension';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import FileCopyIcon from '@material-ui/icons/FileCopy'; // veya 'ContentCopy'
import ImageSearchIcon from '@material-ui/icons/ImageSearch';
import InfoIcon from '@material-ui/icons/Info';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import PowerIcon from '@material-ui/icons/Power';
import ReportIcon from '@material-ui/icons/Report'; // Garanti Dışı için
import SendIcon from '@material-ui/icons/Send';
import SettingsRemoteIcon from '@material-ui/icons/SettingsRemote';
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import logger from 'src/utils/logger';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser'; // Garanti İçi için
import Alert1 from '@material-ui/lab/Alert';
import { SwipeableListItem } from '@sandstreamdev/react-swipeable-list';
import '@sandstreamdev/react-swipeable-list/dist/styles.css';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Chart } from 'react-charts';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { AiOutlineControl } from 'react-icons/ai';
import { BsArrowDownShort } from 'react-icons/bs';
import { FaTree } from 'react-icons/fa';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import Alert from 'src/components/Alert';
import {
  default as BarkodPopup,
  default as BarkodPopupMalzemeYeni
} from 'src/components/BarcodePopup';
import OcakBilgiVermeForm from 'src/components/CookerInformationForm';
import {
  default as MontajForm,
  default as UzaktanKumandaForm
} from 'src/components/InstallForm';
import ProductImage from 'src/components/ProductImage/PickArea';
import axios from 'src/utils/axios';
import {
  loadBaslandiJob,
  saveBaslandiJob
} from 'src/utils/storage/StartWorkOrder';
import { text } from '../modules/languages/index';
import {
  getHistoricalMaterialRequest,
  setCurrentDefect,
  setDefectFilterKey,
  setLabourFilterKey,
  setLabourSelection,
  setMaterialFilterKey,
  setMaterialSelection
} from '../store/actions';
import ComplexSwipeContent from './ComplexSwipeContent';
import Dezenfeksiyon from './Disinfection';
import DoraPowerMeasureCreate from './DoraPowerMeasure';
import PrinterKey from './PrinterKey';
import SelectDefect from './SelectDefect';
import SelectLabour from './SelectLabour';
import SelectMaterial from './SelectMaterial';
import SoftwareDownload from './SoftwareDownload';

const useStyles = makeStyles(theme => ({
  root: {},
  ListDiv: {
    backgroundColor: theme.palette.common.siyah
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    })
  },
  error: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  },
  value: {
    fontWeight: theme.typography.fontWeightMedium
  },
  type: {
    fontWeight: theme.typography.fontWeightMedium
  },
  search: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIcon: {
    marginRight: theme.spacing(2),
    color: theme.palette.icon
  },
  searchInput: {
    flexGrow: 1
  },
  pageStyle: {
    display: 'flex',
    padding: '2px 4px'
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1
  },
  iconButton: {
    padding: 10
  },
  divider: {
    height: 28,
    margin: 4
  },
  searchButton: {
    backgroundColor: theme.palette.common.white,
    marginLeft: theme.spacing(2)
  },
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  content: {
    marginLeft: theme.spacing(0)
  },
  nested: {
    backgroundColor: theme.palette.common.white,
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  nestedRight: {
    backgroundColor: theme.palette.common.white,
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(7)
  },
  smallIcon: {
    height: 15,
    width: 15
  },
  toplam: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    align: 'right',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  action: {
    paddingTop: 12
  },
  submitButtonWudaq: {
    marginTop: theme.spacing(0),
    width: '100%'
  },
  button: {
    marginTop: theme.spacing(1),
    width: '50%'
  }
}));

const defaultProps = {
  bgcolor: 'background.paper',
  // borderColor: "grey.500",
  borderColor: '#FF9800',
  border: 1,
  marginLeft: 0.5,
  marginRight: 0.5,
  marginBottom: 0.5
};

const defaultPropsChild = {
  bgcolor: 'background.paper',
  // borderColor: "#FF9800",
  borderColor: '#cfcfcf',
  border: 1,
  marginLeft: 0.5,
  marginRight: 0.5,
  marginBottom: 0.5
};

const SmallAvatar = withStyles(() => ({
  root: {
    width: 20,
    height: 20
    // border: `2px solid ${theme.palette.background.paper}`,
  }
}))(Avatar);

function HizmetPage(props) {
  const classes = useStyles();
  const [openDefect, setOpenDefect] = React.useState(false);
  const [openMaterial, setOpenMaterial] = React.useState(false);
  const [ProductImageOpen, setProductImageOpen] = React.useState(false);
  const [openLabour, setOpenLabour] = React.useState(false);
  const [materialSum, setMaterialSum] = React.useState(0);
  const [labourSum, setLabourSum] = React.useState(0);
  const [stokOpen, setStokOpen] = React.useState(false);
  const [NonIotOpen, setNonIotOpen] = React.useState(false);
  const [SoftwareDownloadOpen, setSoftwareDownloadOpen] = React.useState(false);
  const [
    DoraPowerMeasureCreateOpen,
    setDoraPowerMeasureCreateOpen
  ] = React.useState(false);
  const [MontajKontrolOpen, setMontajKontrolOpen] = React.useState(false);
  const [montajFormCompleted, setMontajFormCompleted] = React.useState(false);
  const [iadeKontrolOpen, setIadeKontrolOpen] = React.useState(false);
  const [ankastreMontajOpen, setAnkastreMontajOpen] = React.useState(false);
  const [otherActionsPopUp, setOtherActionsPopUp] = React.useState(false);
  const [OcakBilgiOpen, setOcakBilgiOpen] = React.useState(false);
  const [BilgiVermeSayi, setBilgiVermeSayi] = React.useState(4051);

  const [ankastreMontajUygunUrun, setAnkastreMontajUygunUrun] = React.useState(
    false
  );
  const [
    gazliAnkastreMontajUygunUrun,
    setGazliAnkastreMontajUygunUrun
  ] = React.useState(0);
  const [
    gazliAnkastreMontajUygunUrunOpen,
    setGazliAnkastreMontajUygunUrunOpen
  ] = React.useState(false);
  const [uzaktanKumandaArizaOpen, setUzaktanKumandaArizaOpen] = React.useState(
    false
  );

  const [stokData, setStokData] = React.useState([]);
  const [MalzemeEskisiEsleData, setMalzemeEskisiEsleData] = React.useState([]);
  const [MalzemeEskisiEsleOpen, setMalzemeEskisiEsleOpen] = React.useState(
    false
  );
  const [GosterimAdet, setGosterimAdet] = React.useState(30);
  const [open, setOpen] = React.useState(false);
  const [ProductImageFisNo, setProductImageFisNo] = React.useState(0);
  const [TopProductImage, setTopProductImage] = React.useState('');
  const [openBarkod, setOpenBarkod] = useState(false);
  const [openBarkodYeni, setOpenBarkodYeni] = useState(false);
  const [hizmetNotu, setHizmetNotu] = useState('');
  const [LoadingControl, setLoadingControl] = useState(false);
  const [grafikGetir, setgrafikGetir] = React.useState(true);
  const [Uyari, setUyari] = React.useState(false);
  const [Uyari2, setUyari2] = React.useState(false);
  const [Uyari3, setUyari3] = React.useState(false);
  const [Uyari4, setUyari4] = React.useState(false);
  const [uyariTip, setUyariTip] = useState();
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [getDamages, setGetDamages] = React.useState(false);
  const [perspective, setPerspective] = React.useState('');
  const [icDamages, setICDamages] = React.useState([]);
  const [NormalUrunIsaret, setNormalUrunIsaret] = React.useState(false);
  const [NormalUrunIsaretTarih, setNormalUrunIsaretTarih] = React.useState('');
  const [
    downloadSoftwareStatusScreenOpen,
    setDownloadSoftwareStatusScreenOpen
  ] = React.useState(false);
  const [doraStatuPopUpOpen, setDoraStatuPopUpOpen] = React.useState(false);
  const [
    downloadSoftwareStatusResponseMessage,
    setDownloadSoftwareStatusResponseMessage
  ] = useState({});
  const [doraStatuResponseMessage, setDoraStatuResponseMessage] = useState({});
  const [MalzemeEskisiEsleMalzemeId, setMalzemeEskisiEsleMalzemeId] = useState(
    0
  );
  const [
    MalzemeEskisiEsleMalzemeYeniId,
    setMalzemeEskisiEsleMalzemeYeniId
  ] = useState(0);
  const [productTopModelCode, setProductTopModelCode] = useState(0);
  const [productUserModelCode, setProductUserModelCode] = useState(0);
  const [hataKodu, setHataKodu] = useState('');
  const [hataYok, setHataYok] = useState(false);
  const [hataTipi, setHataTipi] = useState('E');
  const [hataGerekli, setHataGerekli] = useState(false);
  const [FormTipId, setFormTipId] = useState(0);
  const [
    arızaDetayNotuDinamikGrupları,
    setArızaDetayNotuDinamikGrupları
  ] = useState([]);
  const [
    TvUzaktanKumandaUyariPopUp,
    setTvUzaktanKumandaUyariPopUp
  ] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };
  const handleCopy = () => {
    navigator.clipboard.writeText(hizmetNotu);
    // Opsiyonel: Kullanıcıya kopyalandığına dair bir bildirim (alert veya snackbar) gösterebilirsin.
    alert('Not kopyalandı!');
  };

  const handleCloseAway = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
    setUyari2(false);
  };
  const jobData = loadBaslandiJob();
  // 2. useEffect içinde bu veriyi izleyin
  useEffect(() => {
    if (jobData?.[0]?.TopProductImage) {
      setTopProductImage(jobData[0].TopProductImage);
    }
  }, [jobData]); // Sadece veri değiştiğinde çalışır

  const tasks = props.tasks?.tasks;

  useEffect(() => {
    let storeData = tasks?.filter(
      d => parseInt(d.FisNo) === parseInt(props.FisNo)
    );
    const jobs = loadBaslandiJob();
    let job = jobs && jobs.length > 0 ? jobs[0] : null;
    if (job?.FisNo === props.FisNo) {
      setNormalUrunIsaret(job.NORMAL_URUN_ISARET || false);
      setNormalUrunIsaretTarih(job.NORMAL_URUN_ISARET_TARIH || '');
      setHizmetNotu(job.HIZMET_NOTU || '');
    } else {
      if (storeData?.length > 0) {
        setNormalUrunIsaret(storeData[0]?.NORMAL_URUN_ISARET || false);
        setNormalUrunIsaretTarih(storeData[0]?.NORMAL_URUN_ISARET_TARIH || '');
        setHizmetNotu(storeData[0]?.HIZMET_NOTU || '');
      }
    }
  }, [props.FisNo, tasks]);

  useEffect(() => {
    let currMaterialSum = 0;
    let currLabourSum = 0;
    if (props.defects && props.defects.selected) {
      props.defects.selected.forEach((row, index) => {
        if (props.materials && props.materials?.materialsTable) {
          if (props.materials[row]) {
            props.materials[row].forEach((mrow, index) => {
              const materialData = props.materials?.materialsTable?.[mrow];
              if (materialData && materialData.PriceWithWat) {
                currMaterialSum +=
                  props.materials[mrow] * materialData.PriceWithWat;
              }
            });
          }
        }
        if (props.labours && props.labours?.laboursTable) {
          if (props.labours[row]) {
            props.labours[row].forEach((mrow, index) => {
              currLabourSum +=
                parseInt(props?.garantiTipi) === 1
                  ? props?.labours?.laboursTable[mrow]?.PriceWithoutWarranty
                  : props?.labours?.laboursTable[mrow]?.Price;
            });
          }
        }
      });
    }
    setMaterialSum(currMaterialSum);
    setLabourSum(currLabourSum);
  }, [
    props.defects,
    props.labours,
    props.materials,
    props.garantiTipi,
    props.FisNo,
    props.tasks
  ]);

  const GetProductTopModelCode = useCallback(() => {
    var userModelCode;
    const jobs = loadBaslandiJob();
    let job = jobs && jobs.length > 0 ? jobs[0] : null;
    if (job?.FisNo === props.FisNo) {
      userModelCode = job?.KUL_MODEL_KODU;
    } else {
      let storeData = props.tasks?.tasks?.filter(
        d => parseInt(d.FisNo) === parseInt(props.FisNo)
      );

      if (storeData?.length > 0) {
        userModelCode = storeData[0]?.KUL_MODEL_KODU;
      }
    }

    // Eğer job veya tasks'tan bulunamazsa, props'tan al
    if (!userModelCode && props.kulModelKodu) {
      userModelCode = props.kulModelKodu;
    }

    if (!userModelCode) return;
    axios
      .get('/GetProductMainTopModelCode/' + (userModelCode || 'a'))
      .then(res => {
        const modelCode = Number(String(res.data).trim());
        logger.log(
          'DefectPage: Product Top Model Code:',
          modelCode,
          'Type:',
          typeof modelCode
        );
        setProductTopModelCode(modelCode);
      })
      .catch(err => {
        logger.error('DefectPage: Product Top Model Code alınamadı:', err);
      });
    setProductUserModelCode(userModelCode);
  }, [props.FisNo, props.tasks, props.kulModelKodu]);

  const checkGazliUrunMontaj = useCallback(() => {
    axios.get('/CheckExistsFileOrSurvey/' + props.FisNo + '/4').then(res => {
      if (res.data === 1) {
        setGazliAnkastreMontajUygunUrun(1);
      } else {
        setGazliAnkastreMontajUygunUrun(0);
      }
    });
  }, [props.FisNo]);

  const CheckHataKoduGerekliMi = useCallback(() => {
    var userModelCode;
    var basned;

    const jobs = loadBaslandiJob();
    let job = jobs && jobs.length > 0 ? jobs[0] : null;
    let storeData = props.tasks?.tasks?.filter(
      d => parseInt(d.FisNo) === parseInt(props.FisNo)
    )?.[0];

    if (!job && !storeData) return;

    basned = job?.BasvuruNedeni || storeData?.BasvuruNedeni;
    userModelCode = job?.KUL_MODEL_KODU || storeData?.KUL_MODEL_KODU;
    if (
      job.ARIZA_HATA_KODU &&
      job.ARIZA_HATA_KODU !== '' &&
      job.ARIZA_HATA_KODU !== -2
    ) {
      setHataGerekli(true);
      return;
    }

    const body = {
      BasvuruNedeni: basned,
      KulModelKodu: userModelCode
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post(`/GetCheckHataKoduGerekliMi`, body, config).then(res => {
      if (res.data === 1) {
        setHataGerekli(true);
        const jobs = loadBaslandiJob();
        let job = jobs && jobs.length > 0 ? jobs[0] : null;
        if (!job) return;
        job = {
          ...job,
          ARIZA_HATA_KODU: -2,
          ARIZA_HATA_KODU_NUM: -2
        };
        saveBaslandiJob(job);
        setUyariTip('error');
        setUyariAciklama(
          'Üründe tespit edilen hata/servis fonksiyon test sonuçu kodu seçilmelidir.'
        );
        setUyari4(true);
      }
    });
  }, [props.FisNo, props.tasks]);

  //MHTU-4764 gazli urun montaj için eklendi
  const ArızaDetayNotuYazılmasıGerekenHizmetDinamikGruplar = useCallback(() => {
    axios
      .get('/GetArizaDetayNotuYazilmasiGerekenHizmetDinamikGruplar/')
      .then(res => {
        if (res.data.length > 0) {
          setArızaDetayNotuDinamikGrupları(res.data);
        }
      })
      .catch(() => {
        // Hata yönetimi
      });
  }, []);

  useEffect(() => {
    let isMounted = true;

    const checkAkastreMontaj = () => {
      axios
        .get('/CheckExistsFileOrSurvey/' + props.FisNo + '/3')
        .then(res => {
          if (isMounted && res.data === 1) {
            setAnkastreMontajUygunUrun(1);
          } else if (isMounted) {
            setAnkastreMontajUygunUrun(0);
          }
        })
        .catch(() => {
          // Hata yönetimi
        });
    };
    checkAkastreMontaj();
    checkGazliUrunMontaj();
    GetProductTopModelCode();
    if (props.readonly === false) {
      CheckHataKoduGerekliMi();
    }
    ArızaDetayNotuYazılmasıGerekenHizmetDinamikGruplar();

    return () => {
      isMounted = false;
    };
  }, [
    ArızaDetayNotuYazılmasıGerekenHizmetDinamikGruplar,
    CheckHataKoduGerekliMi,
    GetProductTopModelCode,
    checkGazliUrunMontaj,
    props.FisNo,
    props.readonly
  ]);

  // FormTipId'yi ayarlamak için useEffect
  const defectsSelected = props?.defects?.selected;
  useEffect(() => {
    if (productTopModelCode === 18596) {
      setFormTipId(1000);
    } else if (productTopModelCode === 28549) {
      const IsMontajSuArıtma = defectsSelected?.filter(
        d => d === 1742 || d === 235
      );
      const IsMontajSuArıtmaFiltreDegisim = defectsSelected?.filter(
        d => d === 1570
      );

      if (IsMontajSuArıtmaFiltreDegisim?.length > 0) {
        setFormTipId(2000);
      } else if (IsMontajSuArıtma?.length > 0) {
        setFormTipId(1000);
      }
    } else {
      setFormTipId(1000);
    }
  }, [productTopModelCode, defectsSelected]);

  const handleSoftwareDownloadCompleted = statusResponse => {
    setDownloadSoftwareStatusResponseMessage(statusResponse);
    setDownloadSoftwareStatusScreenOpen(true);
  };
  //MHTU-5990 maddesi istediği ile hizmet tipi arıza ve bilgi verme olan hizmet tiplerine arıza detay notu alanı çıkacak
  const ArizaDetayNotuYazilmasiGerekenHizmetTipleriKontrol = useCallback(() => {
    const selectedCodes = props.defects?.selected?.map(String) ?? [];
    const defectsTable = props.defects?.defectsTable ?? {};

    // Selected'da olan kodları direkt table'da ara
    for (const code of selectedCodes) {
      const defect =
        defectsTable[code] ||
        Object.values(defectsTable).find(d => String(d.Code) === code);

      if (defect && [2, 8].includes(defect.DefectTypeCode)) {
        return true;
      }
    }

    return false;
  }, [props.defects]);

  //MHTU-5990 arıza detay notu yazabilecek dinamik grup hizmet kodları kontrol
  const ArızaDetayNotuYazılmasıGerekenDinamikHizmetKodları = useMemo(() => {
    const selectedCodes = props.defects?.selected?.map(String) || [];
    const hizmetlerArray = Array.isArray(arızaDetayNotuDinamikGrupları)
      ? arızaDetayNotuDinamikGrupları
      : [];

    return hizmetlerArray.some(h =>
      selectedCodes.includes(String(h.HIZMET_KODU))
    );
  }, [props.defects, arızaDetayNotuDinamikGrupları]);

  const IscilikSil = (Iscilik, index, Hizmet) => {
    var Uyari =
      Iscilik?.LabourCode +
      ' ' +
      Iscilik?.LabourDesc +
      ' işçiliğini silmek istediginizden emin misiniz?';
    confirmAlert({
      message: Uyari,
      buttons: [
        {
          label: 'Evet',
          onClick: () => IscilikSilEvet(Iscilik, index, Hizmet)
        },
        {
          label: 'Hayır',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };
  const IscilikSilEvet = (Iscilik, index, Hizmet) => {
    const selected = props.labours[Hizmet] || [];
    const selectedIndex = selected.indexOf(Iscilik.LabourCode);
    let newSelected = [];
    if (selectedIndex === -1) {
      return;
    }
    newSelected = [
      ...selected.slice(0, selectedIndex),
      ...selected.slice(selectedIndex + 1)
    ];
    props.setLabourSelection(Hizmet, newSelected);
  };
  const MalzemeSil = (Malzeme, index, Hizmet) => {
    var Uyari =
      Malzeme?.MaterialCode +
      ' ' +
      Malzeme?.MaterialDesc +
      ' malzemesini silmek istediğinizden emin misiniz?';
    confirmAlert({
      message: Uyari,
      buttons: [
        {
          label: 'Evet',
          onClick: () => MalzemeSilEvet(Malzeme, index, Hizmet)
        },
        {
          label: 'Hayır',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };
  const MalzemeSilEvet = (Malzeme, index, Hizmet) => {
    const selected = props.materials[Hizmet] || [];
    const selectedIndex = selected.indexOf(Malzeme.MaterialCode);
    let newSelected = [];
    if (selectedIndex === -1) {
      return;
    }
    newSelected = [
      ...selected.slice(0, selectedIndex),
      ...selected.slice(selectedIndex + 1)
    ];

    props.setMaterialSelection(Hizmet, newSelected);
  };
  const tarihselAgacSorgula = () => {
    const jobs = loadBaslandiJob();
    const job = jobs && jobs.length > 0 ? jobs[0] : null;
    if (!job) return;
    props.getHistoricalMaterialRequest(
      job.KUL_MODEL_KODU || '',
      job.GARANTI_TIPI || 1,
      1,
      job.UYIL,
      job.UDONEM
    );
  };

  const GetProductImageOpen = () => {
    const jobs = loadBaslandiJob();
    const job = jobs && jobs.length > 0 ? jobs[0] : null;
    if (!job) return;
    setProductImageFisNo(job.FisNo);
    setTopProductImage(job.TopProductImage);
    setProductImageOpen(true);
  };

  const setNonIotChartOpen = () => {
    setgrafikGetir(false);
  };

  const takePerspective = takenPerspective => {
    setPerspective(takenPerspective);
  };

  const takeDamages = takenDamages => {
    if (takenDamages.length === 0) {
      setUyariTip('error');
      setUyari2(true);
      setUyariAciklama('Lütfen Hasarlı Bölge Seçiniz');
      setLoadingControl(false);
      setGetDamages(false);
      return;
    }
    const jobs = loadBaslandiJob();
    const job = jobs && jobs.length > 0 ? jobs[0] : null;
    if (!job) return;
    let productDamages = {
      WorkOrderId: job.FisNo?.toString() || '',
      damages: takenDamages,
      technicianId: job.TEKNISYEN_KODU?.toString() || '',
      topProduct: job.TopProductImage?.toString() || ''
    };
    axios.get(`/DeleteProductDetection/${job.FisNo}`).then(res => {
      if (res.data.ErrorCode === '0') {
        axios.post('/SetProductDetection', productDamages).then(res => {
          const response = res.data.length === 0 ? [] : res.data;
          setGetDamages(false);
          if (response.ErrorCode === '0') {
            setUyari(true);
            setLoadingControl(false);
            setProductImageOpen(false);
          } else {
            setUyariTip('error');
            setUyari2(true);
            setUyariAciklama(response.ErrorCode);
            setLoadingControl(false);
            setGetDamages(false);
            return;
          }
        });
      } else {
        setUyariTip('error');
        setUyari2(true);
        setUyariAciklama(res.data.ErrorCode);
        setLoadingControl(false);
        setGetDamages(false);
        return;
      }
    });
  };

  const handleCloseButton = () => {
    if (filteredDefect?.length > 0 && icDamages.length === 0) {
      setUyari2(true);
      setUyariAciklama('Lütfen Hasarlı Bölge Seçiniz');
      setUyariTip('error');
    } else {
      setProductImageOpen(false);
    }
  };

  const handleMalzemeEskisiEsleOpen = () => {
    setMalzemeEskisiEsleData([]);
    let malzemeler = [];
    props.defects.selected.forEach(s => {
      malzemeler = [...malzemeler, ...props?.materials[s]];
    });
    if (malzemeler.length === 0) {
      setUyari('Önce malzeme seçiniz!..');
      setOpen(true);
      return;
    }
    setMalzemeEskisiEsleOpen(true);
    setLoadingControl(true);

    var WareHouseData = props.tasks?.tasks?.filter(
      d => parseInt(d.FisNo) === parseInt(props.FisNo)
    );

    const job =
      WareHouseData && WareHouseData.length > 0 ? WareHouseData[0] : null;
    if (!job) {
      setLoadingControl(false);
      return;
    }
    let data = [];

    malzemeler.forEach(m => {
      const materialData = props.materials?.materialsTable?.[m];
      data = [
        ...data,
        {
          MALZEME_KODU: materialData?.MaterialId || '',
          MALZEME_STOK_NO: m,
          MALZEME: materialData?.MaterialDesc || '',
          FIS_NO: job.FisNo,
          BIRIM_KODU: job.BIRIM_KODU,
          BASVURU_NO: job.BasvuruNo,
          MALZEME_ESKISI_BARKOD: '',
          MALZEME_YENISI_BARKOD: ''
        }
      ];
    });

    setMalzemeEskisiEsleData(data);

    setLoadingControl(false);
  };
  const handleStokOpen = () => {
    setStokData([]);
    let malzemeler = [];
    props.defects.selected.forEach(s => {
      malzemeler = [...malzemeler, ...props?.materials[s]];
    });
    if (malzemeler.length === 0) {
      setUyari('Önce malzeme seçiniz!..');
      setOpen(true);
      return;
    }
    setStokOpen(true);
    setLoadingControl(true);

    var WareHouseData = props.tasks?.tasks?.filter(
      d => parseInt(d.FisNo) === parseInt(props.FisNo)
    );

    const job =
      WareHouseData && WareHouseData.length > 0 ? WareHouseData[0] : null;
    if (!job) {
      setLoadingControl(false);
      return;
    }
    let data = [];

    malzemeler.forEach(m => {
      data = [
        ...data,
        {
          MALZEME_KODU: props.materials?.materialsTable[m]?.MaterialId,
          MALZEME_STOK_NO: m,
          FIS_NO: job.FisNo,
          BIRIM_KODU: job.BIRIM_KODU,
          BASVURU_NO: job.BasvuruNo
        }
      ];
    });

    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/GetArtemisMaterialControl', data, config)
      .then(response => {
        const res = response.data.length === 0 ? [] : response.data;
        var Data = [];
        res.forEach(item => {
          const parsedData = JSON.parse(item.DATA.replace(/\\/g, ''));
          Data.push(parsedData);
        });
        setStokData(Data);
        setLoadingControl(false);
      })
      .catch(() => {
        setLoadingControl(false);
      });
  };

  const axes = React.useMemo(
    () => [
      { primary: true, type: 'ordinal', position: 'bottom' },
      { position: 'left', type: 'linear', stacked: true }
    ],
    []
  );
  const series = React.useMemo(
    () => ({
      type: 'bar'
    }),
    []
  );
  const data = React.useMemo(
    () => [
      {
        label: 'Series 1',
        dataType: 'ordinal',
        data: [
          ['Sıcaklık', 18],
          ['Gaz', 40]
        ]
      }
    ],
    []
  );

  const filteredDefect = props?.defects?.selected?.filter(
    d => d === 571 || d === 1393 || d === 1311 || d === 3194
  );
  var IsMontaj;
  if (productTopModelCode === 18596) {
    //Buzdolabı
    IsMontaj = props?.defects?.selected?.filter(
      d => d === 235 || d === 1896 || d === 1772 || d === 1887
    );
  } else if (productTopModelCode === 28549) {
    //Su arıtma
    IsMontaj = false;
    var IsMontajSuArıtma;
    var IsMontajSuArıtmaFiltreDegisim;
    IsMontajSuArıtma = props?.defects?.selected?.filter(
      d => d === 1742 || d === 235
    );
    if (IsMontajSuArıtma) {
      IsMontaj = true;
    }
    IsMontajSuArıtmaFiltreDegisim = props?.defects?.selected?.filter(
      d => d === 1570
    );
    if (IsMontajSuArıtmaFiltreDegisim) {
      IsMontaj = true;
    }
  } else {
    IsMontaj = props?.defects?.selected?.filter(d => d === 439 || d === 235);
  }

  var IsGazliUrunMontaj = props?.defects?.selected?.filter(
    d => d === 420 || d === 235
  );
  var IsCookerInformation = props?.defects?.selected?.filter(
    d => d === 236 || d === 999
  );
  var pcOEM = props?.defects?.selected?.filter(d => d === 1695 || d === 1731);
  var isAnkastreMontaj =
    Array.isArray(props?.defects?.selected) &&
    props.defects.selected.filter(value =>
      [503, 566, 1520, 1521, 1700].includes(value)
    ).length > 0 &&
    !props.defects.selected.filter(value =>
      [439, 3160, 3161, 3157].includes(value)
    ).length > 0 &&
    ankastreMontajUygunUrun === 1;

  var IsUzaktanKumandaAriza = props?.defects?.selected?.filter(d => d === 995);

  IsMontaj = Array.isArray(IsMontaj) && IsMontaj.length > 0;
  if (IsGazliUrunMontaj.length > 0 && gazliAnkastreMontajUygunUrun === 1) {
    IsGazliUrunMontaj = true;
  } else {
    IsGazliUrunMontaj = false;
  }
  if (IsCookerInformation.length > 0) {
    IsCookerInformation = true;
  } else {
    IsCookerInformation = false;
  }

  if (
    pcOEM.length > 0 &&
    (window.location.href.includes('local') ||
      window.location.href.includes('test'))
  ) {
    pcOEM = true;
  } else {
    pcOEM = false;
  }

  if (IsUzaktanKumandaAriza.length > 0) {
    IsUzaktanKumandaAriza = true;
  } else {
    IsUzaktanKumandaAriza = false;
  }

  const handleChangeHizmetNotu = e => {
    const value = e.target.value;
    setHizmetNotu(value);
    const jobs = loadBaslandiJob();
    let job = jobs && jobs.length > 0 ? jobs[0] : null;
    if (!job) return;
    job = {
      ...job,
      HIZMET_NOTU: value || ''
    };
    saveBaslandiJob(job);
  };

  const trPerspective = {
    front: 'Ön Taraf',
    back: 'Arka Taraf',
    top: 'Üst Taraf',
    bottom: 'Alt Taraf',
    right: 'Sağ Taraf',
    left: 'Sol Taraf'
  };
  const handleChangeNormalUrun = e => {
    setNormalUrunIsaret(e.target.checked);
    const jobs = loadBaslandiJob();
    let job = jobs && jobs.length > 0 ? jobs[0] : null;
    if (!job) return;
    job = {
      ...job,
      NORMAL_URUN_ISARET: e.target.checked || false
    };
    saveBaslandiJob(job);
  };
  const handleCheckSoftwareDownloadClose = () => {
    setDownloadSoftwareStatusScreenOpen(false);
  };

  const handleCheckDoraStatuClose = () => {
    setDoraStatuPopUpOpen(false);
  };

  const handleCheckSoftwareDownloadOpen = () => {
    const jobs = loadBaslandiJob();
    const job = jobs && jobs.length > 0 ? jobs[0] : null;
    if (!job) return;

    let config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios.get('/CheckSoftwareDownload/' + job.FisNo, config).then(res => {
      setDownloadSoftwareStatusResponseMessage(res.data);
      setDownloadSoftwareStatusScreenOpen(true);
    });
  };

  const handleCheckDoraStatuOpen = () => {
    setLoadingControl(true);
    const jobs = loadBaslandiJob();
    const job = jobs && jobs.length > 0 ? jobs[0] : null;
    if (!job) {
      setLoadingControl(false);
      return;
    }
    axios.get('/CheckDoraPowerStatu/' + job.FisNo).then(res => {
      setDoraStatuResponseMessage(res.data);
      setLoadingControl(false);
      setDoraStatuPopUpOpen(true);
    });
  };

  const history = useHistory();
  const navigateToImageUploadTab = () => {
    const jobs = loadBaslandiJob();
    const job = jobs && jobs.length > 0 ? jobs[0] : null;
    if (!job) return;
    history.push(`/WorkOrder/${job.FisNo}/Fotograf`);
    setUyari3(false);
  };

  const checkBeforeAnkastreAnket = () => {
    axios.get('/CheckExistsFileOrSurvey/' + props.FisNo + '/1').then(res => {
      if (res.data === 1) {
        setAnkastreMontajOpen(true);
      } else {
        setUyariTip('error');
        setUyariAciklama(
          'Lütfen anketi doldurmadan önce montaj alanının resmini çekiniz!'
        );
        setUyari3(true);
      }
    });
  };

  const handleBarkodCloseYeni = async barkod => {
    if (barkod.length === undefined) {
      setOpenBarkodYeni(false);
      return;
    }
    var MalzemeEskisiEsleDataParam = MalzemeEskisiEsleData;
    var index = MalzemeEskisiEsleDataParam.findIndex(
      x => x.MALZEME_KODU === MalzemeEskisiEsleMalzemeYeniId
    );
    MalzemeEskisiEsleDataParam[index].MALZEME_YENISI_BARKOD = barkod;
    setMalzemeEskisiEsleData(MalzemeEskisiEsleDataParam);

    setOpenBarkodYeni(false);
  };

  const handleBarkodClose = async barkod => {
    if (barkod.length === undefined) {
      setOpenBarkod(false);
      return;
    }
    var MalzemeEskisiEsleDataParam = MalzemeEskisiEsleData;
    var index = MalzemeEskisiEsleDataParam.findIndex(
      x => x.MALZEME_KODU === MalzemeEskisiEsleMalzemeId
    );
    MalzemeEskisiEsleDataParam[index].MALZEME_ESKISI_BARKOD = barkod;
    setMalzemeEskisiEsleData(MalzemeEskisiEsleDataParam);

    setOpenBarkod(false);
  };

  const setMalzemeEskisiEsleMalzemeKodu = MalzemeKodu => {
    setMalzemeEskisiEsleMalzemeId(MalzemeKodu);
    setOpenBarkod(true);
  };

  const setMalzemeEskisiEsleMalzemeKoduYeni = MalzemeKodu => {
    setMalzemeEskisiEsleMalzemeYeniId(MalzemeKodu);
    setOpenBarkodYeni(true);
  };

  const setBilgiOpenNew = Param => {
    setBilgiVermeSayi(Param);
    setOcakBilgiOpen(true);
  };

  const handleSendMalzemeEskisiEsle = () => {
    setLoadingControl(true);
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/SetSendMalzemeEskisiEsle', MalzemeEskisiEsleData, config)
      .then(response => {
        setLoadingControl(false);
        setMalzemeEskisiEsleOpen(false);
      })
      .catch(() => {
        setLoadingControl(false);
        setMalzemeEskisiEsleOpen(false);
      });
  };

  const handleChangeHataKodu = value => {
    const jobs = loadBaslandiJob();
    let job = jobs && jobs.length > 0 ? jobs[0] : null;
    if (!job) return;
    if (value === '') {
      job = {
        ...job,
        ARIZA_HATA_KODU: -2,
        ARIZA_HATA_KODU_NUM: -2
      };
    } else {
      job = {
        ...job,
        ARIZA_HATA_KODU: hataTipi + value,
        ARIZA_HATA_KODU_NUM: value,
        ARIZA_HATA_KODU_TIP: hataTipi
      };
    }
    saveBaslandiJob(job);
    setHataKodu(value);
  };

  const handleChangeHataYok = () => {
    const jobs = loadBaslandiJob();
    let job = jobs && jobs.length > 0 ? jobs[0] : null;
    if (!job) return;
    if (hataYok === false) {
      job = {
        ...job,
        ARIZA_HATA_KODU: -1,
        ARIZA_HATA_KODU_NUM: -1
      };
      setHataKodu('');
    } else {
      job = {
        ...job,
        ARIZA_HATA_KODU: -2,
        ARIZA_HATA_KODU_NUM: -2
      };
    }
    saveBaslandiJob(job);
    setHataYok(!hataYok);
  };

  const malzemeGoster = materialCode => {
    const data = {
      MALZEME_STOK_NO: materialCode.MaterialCode
    };
    const config = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    let newWindow = window.open();
    if (!newWindow) {
      alert(
        "Popup engelleyici aktif. Lütfen bu site için popup'lara izin verin."
      );
      return;
    }
    axios
      .post('/FileImportExport/ArtemisMalzeme', data, config)
      .then(response => {
        var fileURL = URL.createObjectURL(response.data);
        newWindow.location = fileURL;
        newWindow.document.title = materialCode.MaterialCode;
      });
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          {'Bilgilendirme'}
        </DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari}
          </DialogContentText>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            onClick={handleClose}
            variant="contained"
            color="secondary"
            startIcon={<ThumbUpAltIcon />}
          >
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
      <Card>
        <CardHeader
          avatar={
            <IconButton
              edge="end"
              size="small"
              disabled={props.readonly}
              onClick={() => setOpenDefect(true)}
            >
              <Badge
                overlap="circular"
                size="small"
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right'
                }}
                badgeContent={
                  <SmallAvatar
                    style={{ backgroundColor: '#FF9800', color: '#424242' }}
                  >
                    +
                  </SmallAvatar>
                }
              >
                <Avatar
                  style={{ backgroundColor: '#424242', color: '#FF9800' }}
                >
                  H
                </Avatar>
              </Badge>
            </IconButton>
          }
          title={<Typography variant="h6">Hizmet Ekle</Typography>}
          action={
            <IconButton
              edge="end"
              size="small"
              disabled={props.readonly}
              className={classes.action}
              onClick={() => tarihselAgacSorgula()}
            >
              <Badge
                overlap="circular"
                size="small"
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right'
                }}
                badgeContent={
                  <SmallAvatar
                    style={{ backgroundColor: '#FF9800', color: '#424242' }}
                  >
                    <BsArrowDownShort />
                  </SmallAvatar>
                }
              >
                <Avatar
                  style={{ backgroundColor: '#424242', color: '#FF9800' }}
                >
                  <FaTree />
                </Avatar>
              </Badge>
            </IconButton>
          }
        ></CardHeader>
        <List component="div" dense={true}>
          {Array.isArray(props.defects.selected) &&
            props.defects.selected &&
            props.defects.selected.map((row, index) => {
              if (!props.defects.defectsTable) return null;
              const dd = props.defects.defectsTable[row];
              const montaj = dd?.DefectTypeCode === 3;
              // if (montaj == true){
              //   setIsMontaj(true);
              // }
              // (dd?.DefectTypeCode === 3);
              return (
                dd && (
                  <Box key={row} borderRadius={16} {...defaultProps}>
                    <ListItem key={row}>
                      <ListItemText
                        primary={
                          <Typography variant="h6">
                            {dd.UserCode + ' - ' + dd.DefectDesc}
                          </Typography>
                        }
                      />
                      {!props.readonly && (
                        <div>
                          <IconButton
                            edge="end"
                            size="small"
                            disabled={props.readonly}
                            onClick={() => {
                              props.setCurrentDefect(row);
                              setOpenLabour(true);
                            }}
                          >
                            <Badge
                              overlap="circular"
                              size="small"
                              anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right'
                              }}
                              badgeContent={
                                <SmallAvatar
                                  style={{
                                    backgroundColor: '#FF9800',
                                    color: '#424242'
                                  }}
                                >
                                  +
                                </SmallAvatar>
                              }
                            >
                              <Avatar
                                style={{
                                  backgroundColor: '#424242',
                                  color: '#FF9800'
                                }}
                              >
                                I
                              </Avatar>
                            </Badge>
                          </IconButton>
                          <IconButton
                            edge="end"
                            size="small"
                            disabled={props.readonly}
                            onClick={() => {
                              props.setCurrentDefect(row);
                              setOpenMaterial(true);
                            }}
                          >
                            <Badge
                              overlap="circular"
                              size="small"
                              anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right'
                              }}
                              badgeContent={
                                <SmallAvatar
                                  style={{
                                    backgroundColor: '#FF9800',
                                    color: '#424242'
                                  }}
                                >
                                  +
                                </SmallAvatar>
                              }
                            >
                              <Avatar
                                style={{
                                  backgroundColor: '#424242',
                                  color: '#FF9800'
                                }}
                              >
                                M
                              </Avatar>
                            </Badge>
                          </IconButton>
                        </div>
                      )}
                    </ListItem>
                    {/* 3D Printer Key  */}
                    {!props.readonly &&
                      montaj &&
                      props.kulModelKodu === '8817041100' && (
                        <ListItem>
                          <PrinterKey
                            readonly={props.readonly}
                            className={classes.nestedRight}
                          />{' '}
                        </ListItem>
                      )}
                    <Box borderRadius={16} {...defaultPropsChild}>
                      {props.labours &&
                        Array.isArray(props.labours[row]) &&
                        props.labours[row] &&
                        props.labours[row].map((mrow, index) => (
                          <ListItem dense={true} key={mrow}>
                            <SwipeableListItem
                              dense={true}
                              swipeLeft={{
                                content: (
                                  <ComplexSwipeContent
                                    icon={<DeleteSweepIcon />}
                                    label="Sil"
                                    position="right"
                                    css="hizmet"
                                  />
                                ),
                                action: () =>
                                  IscilikSil(
                                    props.labours?.laboursTable[mrow],
                                    index,
                                    row
                                  )
                              }}
                              blockSwipe={props.readonly}
                            >
                              <ListItemText>
                                <Typography
                                  key={mrow}
                                  variant="body1"
                                  className={classes.nestedRight}
                                >
                                  <b>{mrow + ' '}</b>
                                  {props.labours?.laboursTable[mrow]
                                    ?.LabourDesc + ' işçiliği '}
                                </Typography>
                                {mrow !== '880' ? (
                                  <Divider />
                                ) : (
                                  <Dezenfeksiyon readonly={props.readonly} />
                                )}
                              </ListItemText>
                              <ListItemSecondaryAction
                                className={classes.nested}
                              >
                                <Typography variant="h6">
                                  {(parseInt(props.garantiTipi) === 1
                                    ? props.labours?.laboursTable[
                                        mrow
                                      ].PriceWithoutWarranty?.toFixed(2)
                                    : props.labours?.laboursTable[
                                        mrow
                                      ].Price?.toFixed(2)) + ' ₺'}
                                </Typography>
                              </ListItemSecondaryAction>
                            </SwipeableListItem>
                          </ListItem>
                        ))}
                    </Box>
                    <Box borderRadius={16} {...defaultPropsChild}>
                      {props.materials &&
                        Array.isArray(props.materials[row]) &&
                        props.materials[row] &&
                        props.materials[row].map((mrow, index) => (
                          <ListItem dense={true} key={mrow}>
                            <SwipeableListItem
                              dense={true}
                              swipeLeft={{
                                content: (
                                  <ComplexSwipeContent
                                    icon={<DeleteSweepIcon />}
                                    label="Sil"
                                    position="right"
                                    css="hizmet"
                                  />
                                ),
                                action: () =>
                                  MalzemeSil(
                                    props.materials?.materialsTable?.[mrow],
                                    index,
                                    row
                                  )
                              }}
                              swipeRight={{
                                content: (
                                  <ComplexSwipeContent
                                    icon={<ImageSearchIcon />}
                                    label="Malzeme Resmini Göster"
                                    position="left"
                                    css="hizmet"
                                  />
                                ),
                                action: () =>
                                  malzemeGoster(
                                    props.materials?.materialsTable?.[mrow]
                                  )
                              }}
                              blockSwipe={props.readonly}
                            >
                              <ListItemText>
                                <Typography
                                  key={mrow}
                                  variant="body1"
                                  className={classes.nestedRight}
                                >
                                  <b>{mrow}</b>
                                  {' ' +
                                    (props.materials?.materialsTable?.[mrow]
                                      ?.MaterialDesc || '') +
                                    ' Ref:' +
                                    (props.materials?.materialsTable?.[mrow]
                                      ?.Ref || '')}
                                </Typography>
                                <Divider />
                              </ListItemText>
                              <ListItemSecondaryAction
                                className={classes.nested}
                              >
                                <Typography variant="h6">
                                  {(props.materials?.materialsTable?.[
                                    mrow
                                  ]?.PriceWithWat?.toFixed(2) || '0.00') + ' ₺'}
                                  <br />
                                  <Typography variant="body1">
                                    {(props.materials[mrow] || '1') + ' Adet'}
                                  </Typography>
                                </Typography>
                              </ListItemSecondaryAction>
                            </SwipeableListItem>
                          </ListItem>
                        ))}
                    </Box>
                  </Box>
                )
              );
            })}
        </List>

        <Divider />
        <Grid container spacing={0}>
          <Grid item xs={7}></Grid>
          <Grid item xs={4} align="right">
            <br></br>
            <Typography
              className={classes.title}
              variant="h5"
              color="textSecondary"
              gutterBottom
            >
              <b>
                <Chip
                  component="a"
                  label={props.garantiTipiText}
                  icon={
                    props.garantiTipiText === 'Garanti Dışı' ? (
                      <ReportIcon style={{ color: '#d32f2f' }} />
                    ) : (
                      <VerifiedUserIcon style={{ color: '#ffffff' }} />
                    )
                  }
                  style={{
                    backgroundColor:
                      props.garantiTipiText === 'Garanti Dışı'
                        ? '#ffebee'
                        : '#FF9800',
                    color: '#424242' // Yazı rengini de okunabilirlik için ayarladık
                  }}
                />
              </b>
            </Typography>
          </Grid>
          <Grid item xs={1}></Grid>
          <Grid item xs={4}></Grid>
          <Grid item xs={5} align="right">
            <Typography
              className={classes.title}
              color="textSecondary"
              gutterBottom
            >
              {text('iscilik_Toplamı')}
            </Typography>
          </Grid>
          <Grid item xs={2} align="right">
            {/* <b><Chip size="medium" label={labourSum.toFixed(2) + " ₺"} /></b> */}
            <Typography variant="h6" gutterBottom>
              {labourSum.toFixed(2) + '₺'}
            </Typography>
          </Grid>
          <Grid item xs={1}></Grid>
          <Grid item xs={4}></Grid>
          <Grid item xs={5} align="right">
            <Typography
              className={classes.title}
              color="textSecondary"
              gutterBottom
            >
              {text('malzeme_Toplamı')}
            </Typography>
          </Grid>
          <Grid item xs={2} align="right">
            {/* <b><Chip size="medium" label={materialSum.toFixed(2) + " ₺"} /></b> */}
            <Typography variant="h6" gutterBottom>
              {materialSum.toFixed(2) + '₺'}
            </Typography>
          </Grid>
          <Grid item xs={1}></Grid>
          <Grid item xs={12}>
            <Divider variant="inset" />
          </Grid>

          <Grid item xs={6}></Grid>
          <Grid item xs={3} align="right">
            <Typography
              className={classes.title}
              color="textSecondary"
              gutterBottom
            >
              {'Toplam'}
            </Typography>
          </Grid>
          <Grid item xs={2} align="right">
            {/* <b><Chip size="medium" label={(materialSum + labourSum).toFixed(2) + " ₺"} /></b> */}
            <Typography variant="h6" gutterBottom>
              {(materialSum + labourSum).toFixed(2) + '₺'}
            </Typography>
          </Grid>
          <Grid item xs={1}></Grid>
        </Grid>
        <Divider />
        <CardContent className={classes.content}>
          <Grid container spacing={1}>
            <Grid item xs={3}></Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="secondary"
                fullWidth
                size="small"
                onClick={() => setOtherActionsPopUp(true)}
                endIcon={<InfoIcon>Stok</InfoIcon>}
              >
                Arıza Detay Bİlgİlerİ
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="secondary"
                fullWidth
                size="small"
                // disabled={props.readonly}
                onClick={() => handleStokOpen()}
                endIcon={<AiOutlineControl>Stok</AiOutlineControl>}
              >
                Depo Sorgula
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="secondary"
                fullWidth
                size="small"
                // disabled={props.readonly}
                onClick={() => handleMalzemeEskisiEsleOpen()}
                endIcon={<AccountTreeIcon>Stok</AccountTreeIcon>}
              >
                Malzeme Eskİsİ Eşle
              </Button>
            </Grid>

            <Grid item xs={12}>
              <Button
                variant="contained"
                color="secondary"
                fullWidth
                size="small"
                disabled={props.readonly}
                onClick={() => setSoftwareDownloadOpen(true)}
                endIcon={<DeveloperBoardIcon>Stok</DeveloperBoardIcon>}
              >
                Kart Yazılım Yükle
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="secondary"
                fullWidth
                size="small"
                disabled={props.readonly}
                onClick={handleCheckSoftwareDownloadOpen}
                endIcon={<DeviceUnknownIcon>Stok</DeviceUnknownIcon>}
              >
                Kart Yazılım Durum Sorgula
              </Button>
            </Grid>
            {productTopModelCode === 18596 && (
              <>
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    color="secondary"
                    fullWidth
                    size="small"
                    disabled={props.readonly}
                    onClick={() => setDoraPowerMeasureCreateOpen(true)}
                    endIcon={<PowerIcon>Stok</PowerIcon>}
                  >
                    DORA Güç Ölçüm Talebi
                  </Button>
                </Grid>
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    color="secondary"
                    fullWidth
                    size="small"
                    disabled={props.readonly}
                    onClick={handleCheckDoraStatuOpen}
                    endIcon={<DeviceUnknownIcon>Stok</DeviceUnknownIcon>}
                  >
                    DORA Güç Ölçüm Durum Sorgula
                  </Button>
                </Grid>
              </>
            )}
            {TopProductImage !== 'Yok' && filteredDefect?.length > 0 ? (
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="secondary"
                  fullWidth
                  size="small"
                  onClick={() => GetProductImageOpen()}
                  endIcon={<ExtensionIcon>Stok</ExtensionIcon>}
                >
                  Hasar Bölgesi İşaretleme
                </Button>
              </Grid>
            ) : null}
          </Grid>
          <br />
          {IsMontaj ? (
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="secondary"
                fullWidth
                size="small"
                onClick={() => setMontajKontrolOpen(true)}
                endIcon={<PlaylistAddCheckIcon>Check</PlaylistAddCheckIcon>}
              >
                Montaj Kontrol
              </Button>
            </Grid>
          ) : (
            ''
          )}
          <br />
          {IsGazliUrunMontaj ? (
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="secondary"
                fullWidth
                size="small"
                onClick={() => setGazliAnkastreMontajUygunUrunOpen(true)}
                endIcon={<PlaylistAddCheckIcon>Check</PlaylistAddCheckIcon>}
              >
                Gazlı Ürün Montaj Kontrol
              </Button>
            </Grid>
          ) : (
            ''
          )}
          <br />
          {IsCookerInformation ? (
            <Grid container spacing={1}>
              {productTopModelCode === 30131 ? (
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    color="secondary"
                    fullWidth
                    size="small"
                    onClick={() => setBilgiOpenNew(4051)}
                    endIcon={<PlaylistAddCheckIcon>Check</PlaylistAddCheckIcon>}
                  >
                    Ocak Ürün Grubu Bİlgİ Verme
                  </Button>
                </Grid>
              ) : (
                <></>
              )}
              {productTopModelCode === 30173 ? (
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    color="secondary"
                    fullWidth
                    size="small"
                    onClick={() => setBilgiOpenNew(4052)}
                    endIcon={<PlaylistAddCheckIcon>Check</PlaylistAddCheckIcon>}
                  >
                    Fırın Ürün Grubu Bİlgİ Verme
                  </Button>
                </Grid>
              ) : (
                <></>
              )}
              {productTopModelCode === 18369 ? (
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    color="secondary"
                    fullWidth
                    size="small"
                    onClick={() => setBilgiOpenNew(4053)}
                    endIcon={<PlaylistAddCheckIcon>Check</PlaylistAddCheckIcon>}
                  >
                    Çamaşır Ürün Grubu Bİlgİ Verme
                  </Button>
                </Grid>
              ) : (
                <></>
              )}
              {productTopModelCode === 18596 ? (
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    color="secondary"
                    fullWidth
                    size="small"
                    onClick={() => setBilgiOpenNew(4054)}
                    endIcon={<PlaylistAddCheckIcon>Check</PlaylistAddCheckIcon>}
                  >
                    Buzdolabı Ürün Grubu Bilgi Verme
                  </Button>
                </Grid>
              ) : (
                <></>
              )}
              {productTopModelCode === 18597 ? (
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    color="secondary"
                    fullWidth
                    size="small"
                    onClick={() => setBilgiOpenNew(4055)}
                    endIcon={<PlaylistAddCheckIcon>Check</PlaylistAddCheckIcon>}
                  >
                    Klima Ürün Grubu Bilgi Verme
                  </Button>
                </Grid>
              ) : (
                <></>
              )}
              {productTopModelCode === 18366 ? (
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    color="secondary"
                    fullWidth
                    size="small"
                    onClick={() => setBilgiOpenNew(4056)}
                    endIcon={<PlaylistAddCheckIcon>Check</PlaylistAddCheckIcon>}
                  >
                    Bulaşık Ürün Grubu Bilgi Verme
                  </Button>
                </Grid>
              ) : (
                <></>
              )}
              {productTopModelCode === 18367 ? (
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    color="secondary"
                    fullWidth
                    size="small"
                    onClick={() => setBilgiOpenNew(4057)}
                    endIcon={<PlaylistAddCheckIcon>Check</PlaylistAddCheckIcon>}
                  >
                    Kurutma Ürün Grubu Bilgi Verme
                  </Button>
                </Grid>
              ) : (
                <></>
              )}
              {productTopModelCode === 18603 ? (
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    color="secondary"
                    fullWidth
                    size="small"
                    onClick={() => setBilgiOpenNew(4058)}
                    endIcon={<PlaylistAddCheckIcon>Check</PlaylistAddCheckIcon>}
                  >
                    TV Ürün Grubu Bilgi Verme
                  </Button>
                </Grid>
              ) : (
                <></>
              )}
              {productTopModelCode === 28765 ? (
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    color="secondary"
                    fullWidth
                    size="small"
                    onClick={() => setBilgiOpenNew(4059)}
                    endIcon={<PlaylistAddCheckIcon>Check</PlaylistAddCheckIcon>}
                  >
                    OKC Ürün Grubu Bilgi Verme
                  </Button>
                </Grid>
              ) : (
                <></>
              )}
              {productTopModelCode === 18602 ? (
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    color="secondary"
                    fullWidth
                    size="small"
                    onClick={() => setBilgiOpenNew(4060)}
                    endIcon={<PlaylistAddCheckIcon>Check</PlaylistAddCheckIcon>}
                  >
                    Robot Süpürge Ürün Grubu Bilgi Verme
                  </Button>
                </Grid>
              ) : (
                <></>
              )}
            </Grid>
          ) : (
            <></>
          )}
          <br />
          {pcOEM ? (
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="secondary"
                fullWidth
                size="small"
                onClick={() => setIadeKontrolOpen(true)}
                endIcon={<PlaylistAddCheckIcon>Check</PlaylistAddCheckIcon>}
              >
                İade Kontrol
              </Button>
            </Grid>
          ) : (
            ''
          )}
          <br />
          {isAnkastreMontaj ? (
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="secondary"
                fullWidth
                size="small"
                onClick={() => checkBeforeAnkastreAnket()}
                endIcon={<PlaylistAddCheckIcon>Check</PlaylistAddCheckIcon>}
              >
                Ankastre Montaj
              </Button>
            </Grid>
          ) : (
            ''
          )}
          {IsUzaktanKumandaAriza ? (
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="secondary"
                fullWidth
                size="small"
                onClick={() => setUzaktanKumandaArizaOpen(true)}
                endIcon={<PlaylistAddCheckIcon>Check</PlaylistAddCheckIcon>}
              >
                Uzaktan Kumanda Arıza
              </Button>
            </Grid>
          ) : (
            ''
          )}
        </CardContent>
        <br />
        <SelectDefect
          open={openDefect}
          onClose={async () => {
            setOpenDefect(false);
            if (filteredDefect?.length > 0 && TopProductImage !== 'Yok') {
              GetProductImageOpen();
            }
            if (IsUzaktanKumandaAriza) {
              setTvUzaktanKumandaUyariPopUp(true);
            }
            if (IsMontaj) {
              try {
                // Form daha önce doldurulmamışsa, API'den veri gelip gelmediğini kontrol et

                const formRes = await axios.get(
                  `/GetArtemisFormMontaj/${FormTipId}/${props.FisNo}/${productUserModelCode}`
                );

                // Response var ve boş değilse formu aç
                if (
                  formRes.data &&
                  Array.isArray(formRes.data) &&
                  formRes.data.length > 0 &&
                  formRes.data[0]?.json &&
                  formRes.data[0].json !== 'undefined' &&
                  formRes.data[0].json !== 'null'
                ) {
                  setMontajKontrolOpen(true);
                }
              } catch (err) {
                // Hata durumunda formu açma
                logger.error('Montaj kontrol kontrolü yapılamadı:', err);
              }
            }
          }}
          title="Hizmet Seçimi"
        />
        <SelectMaterial
          open={openMaterial}
          onClose={() => {
            setOpenMaterial(false);
            setMaterialFilterKey('');
            setGosterimAdet(30);
          }}
          title="Malzeme Seçimi"
          GosterimAdet={GosterimAdet}
          setGosterimAdet={setGosterimAdet}
          defect={props.defects.currentDefect}
        />
        <SelectLabour
          open={openLabour}
          onClose={() => {
            setOpenLabour(false);
            setLabourFilterKey('');
          }}
          garantiTipi={props.garantiTipi}
          title="İşçilik Seçimi"
          defect={props.defects.currentDefect}
        />

        {SoftwareDownloadOpen && (
          <SoftwareDownload
            open={SoftwareDownloadOpen}
            setOpen={setSoftwareDownloadOpen}
            onCompleted={handleSoftwareDownloadCompleted}
            handleCheckSoftwareDownloadOpen={handleCheckSoftwareDownloadOpen}
          />
        )}
        {DoraPowerMeasureCreateOpen && (
          <DoraPowerMeasureCreate
            open={DoraPowerMeasureCreateOpen}
            setOpen={setDoraPowerMeasureCreateOpen}
          />
        )}
        <Dialog
          open={ProductImageOpen}
          onClose={() => setProductImageOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullScreen
        >
          <DialogTitle id="alert-dialog-title">
            Hasar Bölgesi İşaretleme
            <Divider />
          </DialogTitle>
          <DialogContent>
            <Typography
              align={'center'}
            >{`Mevcut Görünüm: ${trPerspective[perspective]}`}</Typography>
            <ProductImage
              takeDamages={takeDamages}
              getDamages={getDamages}
              takePerspective={takePerspective}
              setProductDamages={setICDamages}
              Product={TopProductImage}
              FisNo={ProductImageFisNo}
            />
            <Typography
              align={'center'}
            >{`${icDamages.length} adet hasar seçtiniz.`}</Typography>
          </DialogContent>
          <DialogActions>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Alert1 severity="warning">{'*Görseller semboliktir.'}</Alert1>
              </Grid>
              <Grid item xs={6}>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    setLoadingControl(true);
                    setGetDamages(true);
                  }}
                  className={classes.submitButtonWudaq}
                  endIcon={<SettingsRemoteIcon>Getir</SettingsRemoteIcon>}
                >
                  Gönder
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => handleCloseButton()}
                  className={classes.submitButtonWudaq}
                  endIcon={<CloseIcon>Close</CloseIcon>}
                >
                  Kapat
                </Button>
              </Grid>
            </Grid>
            {LoadingControl ? (
              <Backdrop className={classes.backdrop} open={LoadingControl}>
                <CircularProgress color="inherit" />
              </Backdrop>
            ) : (
              ''
            )}
          </DialogActions>
          {Uyari2 ? (
            <Alert
              onClose={handleCloseAway}
              message={uyariAciklama}
              variant={uyariTip}
            />
          ) : (
            <div></div>
          )}
        </Dialog>
        <Dialog
          open={NonIotOpen}
          onClose={() => setNonIotOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullScreen
        >
          <DialogTitle id="alert-dialog-title">
            Cihaz Arıza Bilgileri!...
            <Divider />
          </DialogTitle>
          <DialogContent>
            {grafikGetir ? (
              <img src={'/images/wudaq.gif'} alt="nice"></img>
            ) : (
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <div
                    style={{
                      height: '400px'
                    }}
                  >
                    <Chart data={data} series={series} axes={axes} />
                  </div>
                </Grid>
              </Grid>
            )}
          </DialogContent>
          <DialogActions>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => setNonIotChartOpen()}
                  className={classes.submitButtonWudaq}
                  endIcon={<SettingsRemoteIcon>Getir</SettingsRemoteIcon>}
                >
                  BİlgİlerİGetİr
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => setNonIotOpen(false)}
                  className={classes.submitButtonWudaq}
                  endIcon={<CloseIcon>Close</CloseIcon>}
                >
                  Kapat
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>
        <Dialog
          open={stokOpen}
          onClose={() => setStokOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullScreen
        >
          <DialogTitle id="alert-dialog-title">Malzeme Stok Durumu</DialogTitle>
          {LoadingControl ? (
            <Backdrop className={classes.backdrop} open={LoadingControl}>
              <CircularProgress color="inherit" />
            </Backdrop>
          ) : (
            ''
          )}
          <Divider />
          <DialogContent>
            {Array.isArray(stokData) &&
              stokData.map(item => (
                <div>
                  <Card>
                    <CardHeader
                      title={
                        <Typography component={'h6'}>
                          <b>{item[0]?.MALZEME}</b>
                        </Typography>
                      }
                    />
                    <Divider />
                    <CardContent>
                      <Grid container spacing={2}>
                        <Grid item xs={12} align="left">
                          <Typography component={'h6'}>
                            {'Açıklama : '}
                            {item[0]?.ACIKLAMA}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} align="left">
                          <Typography component={'h6'}>
                            {'Merkez Adet : '}
                            {item[0]?.MERKEZ_ADET}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} align="left">
                          <Typography component={'h6'}>
                            {'Bölge Adet : '}
                            {item[0]?.BOLGE_ADET}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} align="left">
                          <Typography component={'h6'}>
                            {'Servis Adet : '}
                            {item[0]?.SERVIS_ADET}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} align="left">
                          <Typography component={'h6'}>
                            {'Sevk Edecek : '}
                            {item[0]?.SEVK_EDECEK}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} align="left">
                          <Typography component={'h6'}>
                            {'Sipariş Durum : '}
                            {item[0]?.SIPARIS_DURUM}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} align="left">
                          <Typography component={'h6'}>
                            {'Teslim Tarihi : '}
                            {item[0]?.TEMIN_TARIHI}
                          </Typography>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                  <br />
                </div>
              ))}
          </DialogContent>
          <Divider />
          <DialogActions>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => setStokOpen(false)}
              endIcon={<CloseIcon>Close</CloseIcon>}
            >
              Kapat
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={MalzemeEskisiEsleOpen}
          onClose={() => setMalzemeEskisiEsleOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullScreen
        >
          <DialogTitle id="alert-dialog-title">
            Malzeme Eskisi Barkod Eşleme
          </DialogTitle>
          {LoadingControl ? (
            <Backdrop className={classes.backdrop} open={LoadingControl}>
              <CircularProgress color="inherit" />
            </Backdrop>
          ) : (
            ''
          )}
          <Divider />
          <DialogContent>
            {Array.isArray(MalzemeEskisiEsleData) &&
              MalzemeEskisiEsleData?.map(item => (
                <div key={item?.MALZEME_STOK_NO || item?.MALZEME_YENISI_BARKOD}>
                  <Card>
                    <CardContent>
                      <Grid container spacing={2}>
                        <Grid item xs={12} align="left">
                          <Typography component={'h6'}>
                            {item?.MALZEME_STOK_NO + ' ' + item?.MALZEME}
                          </Typography>
                          <Typography component={'h6'}>
                            <b>{'Barkod : '}</b>
                            {item?.MALZEME_YENISI_BARKOD}
                          </Typography>
                        </Grid>
                      </Grid>
                    </CardContent>
                    <Divider />
                    <CardActions>
                      <Button
                        variant="contained"
                        color="secondary"
                        fullWidth
                        onClick={() =>
                          setMalzemeEskisiEsleMalzemeKoduYeni(
                            item?.MALZEME_KODU
                          )
                        }
                        endIcon={<CropFreeIcon>Close</CropFreeIcon>}
                      >
                        ÜRÜNE TAKILAN YENİ MAZLEME ÜZERİNDEKİ BARKOD
                      </Button>
                    </CardActions>
                    <Divider />
                    <CardContent>
                      <Grid container spacing={2}>
                        <Grid item xs={12} align="left">
                          <Typography component={'h6'}>
                            <b>{'Barkod : '}</b>
                            {item?.MALZEME_ESKISI_BARKOD}
                          </Typography>
                        </Grid>
                      </Grid>
                    </CardContent>
                    <Divider />
                    <CardActions>
                      <Button
                        variant="contained"
                        color="secondary"
                        fullWidth
                        onClick={() =>
                          setMalzemeEskisiEsleMalzemeKodu(item?.MALZEME_KODU)
                        }
                        endIcon={<CropFreeIcon>Close</CropFreeIcon>}
                      >
                        ÜRÜNDEN SÖKÜLEN MALZEME ÜZERİNDEKİ BARKOD
                      </Button>
                    </CardActions>
                    <BarkodPopup
                      onClose={handleBarkodClose}
                      open={openBarkod}
                      ScanTime={0}
                      CallScreen={0}
                    />
                    <BarkodPopupMalzemeYeni
                      onClose={handleBarkodCloseYeni}
                      open={openBarkodYeni}
                      ScanTime={0}
                      CallScreen={0}
                    />
                  </Card>
                  <br />
                </div>
              ))}
          </DialogContent>
          <Divider />
          <DialogActions>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => handleSendMalzemeEskisiEsle()}
              endIcon={<SendIcon>Close</SendIcon>}
            >
              Gönder
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => setMalzemeEskisiEsleOpen(false)}
              endIcon={<CloseIcon>Close</CloseIcon>}
            >
              Kapat
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={MontajKontrolOpen}
          onClose={() => {
            setMontajKontrolOpen(false);
            setMontajFormCompleted(false); // Dialog kapanırken state'i resetle
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullScreen
        >
          <DialogTitle id="alert-dialog-title">
            Montaj Kontrol Listesi
            <Divider />
          </DialogTitle>
          <DialogContent>
            <MontajForm
              Id={FormTipId}
              FisNo={props.FisNo}
              userModelCode={productUserModelCode}
              onClose={() => setMontajKontrolOpen(false)}
              onFormComplete={() => setMontajFormCompleted(true)}
            />
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                setMontajKontrolOpen(false);
                setMontajFormCompleted(false);
              }}
              className={classes.button}
              disabled={
                !montajFormCompleted &&
                (FormTipId === 1000 || FormTipId === 2000)
              }
              endIcon={<CloseIcon>Close</CloseIcon>}
            >
              Kapat
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={iadeKontrolOpen}
          onClose={() => setIadeKontrolOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullScreen
        >
          <DialogTitle id="alert-dialog-title">
            Bilgisayar Bileşen İadesi Kontrol
            <Divider />
          </DialogTitle>
          <DialogContent>
            <MontajForm Id={3000} FisNo={props.FisNo} />
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => setIadeKontrolOpen(false)}
              className={classes.button}
              endIcon={<CloseIcon>Close</CloseIcon>}
            >
              Kapat
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={OcakBilgiOpen}
          onClose={() => setOcakBilgiOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullScreen
        >
          <DialogTitle id="alert-dialog-title">
            Bilgi Verme
            <Divider />
          </DialogTitle>
          <DialogContent>
            <OcakBilgiVermeForm Id={BilgiVermeSayi} FisNo={props.FisNo} />
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => setOcakBilgiOpen(false)}
              className={classes.button}
              endIcon={<CloseIcon>Close</CloseIcon>}
            >
              Kapat
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={ankastreMontajOpen}
          onClose={() => setAnkastreMontajOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullScreen
        >
          <DialogTitle id="alert-dialog-title">
            Ankastre Montaj Yapılamama Nedeni
            <Divider />
          </DialogTitle>
          <DialogContent>
            <MontajForm Id={4000} FisNo={props.FisNo} />
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => setAnkastreMontajOpen(false)}
              className={classes.button}
              endIcon={<CloseIcon>Close</CloseIcon>}
            >
              Kapat
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={uzaktanKumandaArizaOpen}
          onClose={() => setUzaktanKumandaArizaOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullScreen
        >
          <DialogTitle id="alert-dialog-title">
            Uzaktan Kumanda Arıza Listesi
            <Divider />
          </DialogTitle>
          <DialogContent>
            <UzaktanKumandaForm Id={2000} FisNo={props.FisNo} />
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => setUzaktanKumandaArizaOpen(false)}
              className={classes.button}
              endIcon={<CloseIcon>Close</CloseIcon>}
            >
              Kapat
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={gazliAnkastreMontajUygunUrunOpen}
          onClose={() => setGazliAnkastreMontajUygunUrunOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullScreen
        >
          <DialogTitle id="alert-dialog-title">
            Gazlı Ürün Montaj Kontrol
            <Divider />
          </DialogTitle>
          <DialogContent>
            <UzaktanKumandaForm Id={8888} FisNo={props.FisNo} />
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => setGazliAnkastreMontajUygunUrunOpen(false)}
              className={classes.button}
              endIcon={<CloseIcon>Close</CloseIcon>}
            >
              Kapat
            </Button>
          </DialogActions>
        </Dialog>
        {Uyari ? (
          <Alert
            onClose={handleCloseAway}
            message=" işleminiz Başarı ile Gerçekleştirildi."
            variant="success"
          />
        ) : (
          <div></div>
        )}
      </Card>
      <Dialog
        open={downloadSoftwareStatusScreenOpen}
        onClose={handleCheckSoftwareDownloadClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {'Kart Yazılım Durumu'}
        </DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText id="alert-dialog-description" component="div">
            <Alert1
              severity={
                downloadSoftwareStatusResponseMessage.successful
                  ? 'success'
                  : 'error'
              }
            >
              {downloadSoftwareStatusResponseMessage.successful
                ? 'Kart Yazılım yükleme başarılı'
                : downloadSoftwareStatusResponseMessage?.message ||
                  'Kart Yazılım yükleme başarısız!..'}
            </Alert1>
          </DialogContentText>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleCheckSoftwareDownloadClose}
            className={classes.button}
            endIcon={<CloseIcon>Close</CloseIcon>}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={doraStatuPopUpOpen}
        onClose={handleCheckDoraStatuClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {'Dora Güç Durumu Sorgula'}
        </DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {doraStatuResponseMessage.successful ? (
              // resultData içindeki her item için döngü
              Array.isArray(doraStatuResponseMessage.resultData) &&
              doraStatuResponseMessage.resultData.map(item => (
                <div
                  key={item.powerDataTestResultID}
                  style={{ marginBottom: '10px' }}
                >
                  {/* Adım, Adım Adı ve Güç Sonucu */}
                  <strong>{`Adım ${item.powerDataTestStep}: ${item.powerDataTestStepName} (Güç Sonucu: ${item.powerDataTestStepPowerResult})`}</strong>{' '}
                  <br />
                  {/* Sonuç alanı, "NG" için kırmızı, "OK" için yeşil */}
                  <Alert1
                    severity={
                      item.powerDataTestStepResult === 'NG'
                        ? 'error'
                        : 'success'
                    }
                  >
                    <strong>Sonuç: </strong> {item.powerDataTestStepResult}{' '}
                    <br />
                    {/* "NG" durumunda güç çekim mesajını sonuç içinde göster */}
                    {item.powerDataTestStepResult === 'NG' && (
                      <>
                        {item.powerDataTestStepPowerResult >
                          item.powerDataTestPowerHighLimit && (
                          <span style={{ color: 'red' }}>
                            Yüksek Güç Çekmektedir. Komponent Kontrol
                            Edilmelidir!
                          </span>
                        )}
                        {item.powerDataTestStepPowerResult <
                          item.powerDataTestPowerLowLimit && (
                          <span style={{ color: 'red' }}>
                            Düşük Güç Çekmektedir. Komponent Kontrol
                            Edilmelidir!
                          </span>
                        )}
                      </>
                    )}
                  </Alert1>
                  <Divider style={{ margin: '10px 0' }} />
                </div>
              ))
            ) : (
              <Alert1 severity="error">
                {doraStatuResponseMessage.message}
              </Alert1>
            )}
          </DialogContentText>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleCheckDoraStatuClose}
            className={classes.button}
            endIcon={<CloseIcon>Close</CloseIcon>}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={Uyari3}
        onClose={() => setUyari3(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          {'Bilgilendirme'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {uyariAciklama}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => navigateToImageUploadTab()} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={Uyari4}
        onClose={() => setUyari4(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          {'Dikkat'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {uyariAciklama}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setUyari4(false)} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={TvUzaktanKumandaUyariPopUp}
        onClose={() => setTvUzaktanKumandaUyariPopUp(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <Box display="flex" alignItems="center" mb={2}>
            <FiberManualRecordIcon style={{ color: 'red', marginRight: 8 }} />
            <Typography variant="h6" fontWeight="bold">
              DİKKAT! — UK ARIZASI GİRİŞİ SONRASINDA UYGULANMASI GEREKENLER
            </Typography>
          </Box>

          <Typography paragraph>
            Uzaktan Kumanda (UK) arızası ile ilgili işçilik veya hizmet kaydı
            girildiğinde, aşağıdaki adımların sırasıyla ve eksiksiz şekilde
            uygulanması zorunludur.
          </Typography>

          <Box mb={1} borderBottom="1px solid #ccc" />

          <Typography fontWeight="bold" gutterBottom>
            ● 1. Arıza Formunun Doldurulması
          </Typography>
          <Typography>• TV/2023/036 numaralı bültende yer alan</Typography>
          <Typography>
            • “Uzaktan Kumanda Arıza Formu”, eksiksiz ve doğru şekilde
            doldurulmalıdır.
          </Typography>

          <Box my={1} borderBottom="1px solid #ccc" />

          <Typography fontWeight="bold" gutterBottom>
            ● 2. APK Uygulamasının Yapılması ve QR Kodun Eklenmesi
          </Typography>
          <Typography>• TV/2024/047 numaralı bültende belirtilen</Typography>
          <Typography>
            • "Uzaktan Kumanda APK Uygulama" işlemi mutlaka
            gerçekleştirilmelidir.
          </Typography>
          <Typography>
            • İşlem sonunda oluşturulan QR kod görseli, ilgili servis fişine
            mutlaka eklenmelidir.
          </Typography>

          <Box my={1} borderBottom="1px solid #ccc" />

          <Typography fontWeight="bold" gutterBottom>
            ● 3. Hata Tespiti Prosedürünün Uygulanması
          </Typography>
          <Typography>
            • TV/2024/015 numaralı bültende belirtilen adımlar izlenerek
          </Typography>
          <Typography>
            • Arızalı olduğu düşünülen uzaktan kumandalar için gerekli hata
            tespiti işlemleri eksiksiz uygulanmalıdır.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setTvUzaktanKumandaUyariPopUp(false)}
            color="primary"
          >
            Tamam
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={otherActionsPopUp}
        onClose={() => setOtherActionsPopUp(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          {'Diğer İşlemler'}
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item xs={12} align="left">
              <Typography className={classes.title} color="textSecondary">
                Üründe Sorun Görülmedi, Ürün Normal
                <Checkbox
                  checked={NormalUrunIsaret}
                  color="primary"
                  name="IsProductNormal"
                  disabled={props.readonly}
                  onChange={handleChangeNormalUrun}
                />
              </Typography>
            </Grid>
            <Grid item xs={12} className={classes.title} align="left">
              <Typography color="textSecondary">
                Ürün Normal İşaret Tarihi :{NormalUrunIsaretTarih}
              </Typography>
            </Grid>
            <Grid item xs={12} align="left">
              <Divider />
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12} align="left">
              {(ArizaDetayNotuYazilmasiGerekenHizmetTipleriKontrol() ||
                ArızaDetayNotuYazılmasıGerekenDinamikHizmetKodları) && (
                <div className={classes.fields}>
                  {(hizmetNotu?.length ?? 0) < 5 && (
                    <Alert
                      variant="warning"
                      message="Verilen hizmete ilişkin arıza detayını, yapılan işlemleri detaylı bir şekilde belirtiniz!"
                    />
                  )}
                  <TextField
                    label={'Arıza Detay Notu*'}
                    name="Arıza Detay Notu*"
                    multiline
                    disabled={props.readonly}
                    minRows={4}
                    fullWidth
                    variant="outlined"
                    inputProps={{ maxLength: 2000 }} // HTML input özellikleri
                    InputProps={{
                      // MUI bileşen özellikleri
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleCopy}
                            edge="end"
                            title="Kopyala"
                          >
                            <FileCopyIcon fontSize="small" color="primary" />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                    value={hizmetNotu}
                    onChange={handleChangeHizmetNotu}
                  />
                </div>
              )}
            </Grid>
          </Grid>
          {hataGerekli ? (
            <>
              <Divider />
              <br></br>
              <br></br>
              <Grid container spacing={1}>
                <Grid item xs={12} align="left">
                  <FormControl
                    variant="outlined"
                    className={classes.title}
                    fullWidth
                  >
                    <InputLabel id="demo-simple-select-outlined-label">
                      {'Hata Tipi'}
                    </InputLabel>
                    <Select
                      native
                      value={hataTipi}
                      fullWidth
                      onChange={e => setHataTipi(e.target.value)}
                      disabled={props.readonly || hataYok}
                    >
                      <option value="E" defaultValue>
                        E
                      </option>
                      {/* <option value="Err">Err</option>
                              <option value="CH">CH</option>
                              <option value="H">H</option> */}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} align="left">
                  <TextField
                    className={classes.title}
                    name="HataKodu"
                    label={'Arıza Hata Kodu'}
                    value={hataKodu || ''}
                    type="number"
                    onChange={e => handleChangeHataKodu(e.target.value)}
                    InputLabelProps={{
                      shrink: true
                    }}
                    onInput={e => {
                      e.target.value = Math.max(0, parseInt(e.target.value))
                        .toString()
                        .slice(0, 3);
                    }}
                    fullWidth
                    variant="outlined"
                    disabled={hataYok}
                  />
                </Grid>
                <Grid item xs={12} align="left">
                  <Divider />
                </Grid>
                <Grid item xs={12} className={classes.title} align="left">
                  <Typography className={classes.title} color="textSecondary">
                    Hata Kodu Yok
                    <Checkbox
                      checked={hataYok}
                      color="primary"
                      name="noErrorCode"
                      disabled={props.readonly}
                      onChange={handleChangeHataYok}
                    />
                  </Typography>
                </Grid>
              </Grid>
            </>
          ) : (
            <></>
          )}
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button onClick={() => setOtherActionsPopUp(false)} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const mapStateToProps = state => ({
  defects: state.defectReducer,
  materials: state.materialReducer,
  labours: state.labourReducer,
  tasks: state.tasks1
});

const mapDispatchToProps = {
  setCurrentDefect: setCurrentDefect,
  setDefectFilterKey: setDefectFilterKey,
  setLabourFilterKey: setLabourFilterKey,
  setMaterialFilterKey: setMaterialFilterKey,
  setMaterialSelection: setMaterialSelection,
  setLabourSelection: setLabourSelection,
  getHistoricalMaterialRequest: getHistoricalMaterialRequest
};
mapStateToProps.propTypes = {
  className: PropTypes.string
};

export default connect(mapStateToProps, mapDispatchToProps)(HizmetPage);
